<template>
  <div class="login-container">
    <page-head head-name="欢迎登录" />
    <!-- 登录框 -->
    <div class="content">
      <div class="login-left">
        <div class="login-left-text">供需匹配高效通道</div>
        <div class="login-left-image">
          <img src="@/assets/images/qrcode2.png" alt="">
          <img src="@/assets/images/qrcode1.png" alt="">
        </div>
      </div>
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <div class="title-container">
          <div
            :class="mode == '0' ? 'select' : 'no-select'"
            @click="changeMode(0)"
          >
            帐号登录
          </div>
          <div
            :class="mode == '1' ? 'select' : 'no-select'"
            @click="changeMode(1)"
          >
            验证码登录
          </div>
        </div>

        <!-- 切换二维码登录 -->
        <div class="code">
          <!-- <svg-icon icon-class="user" /> -->
          <img src="@/assets/images/changeCode.png" alt="">
        </div>

        <el-form-item prop="userPhone">
          <span class="svg-container">
            <svg-icon icon-class="user" />
          </span>
          <el-input
            ref="userPhone"
            v-model="loginForm.userPhone"
            placeholder="用户名/手机号"
            name="userPhone"
            type="text"
            tabindex="1"
            auto-complete="on"
          />
        </el-form-item>

        <el-form-item
          v-if="mode == '0'"
          prop="userPassword"
        >
          <span class="svg-container">
            <svg-icon icon-class="password" />
          </span>
          <el-input
            :key="passwordType"
            ref="userPassword"
            v-model="loginForm.userPassword"
            :type="passwordType"
            placeholder="密码"
            name="userPassword"
            tabindex="2"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
          />
          <span
            class="show-pwd"
            @click="showPwd"
          >
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
        </el-form-item>

        <div
          v-if="mode == '1'"
          style="display: flex"
        >
          <el-form-item
            prop="code"
            style="width: 200px"
          >
            <div style="display: flex">
              <span class="svg-container">
                <svg-icon icon-class="safari" />
              </span>
              <el-input
                v-model="loginForm.userCode"
                placeholder="验证码"
                name="userCode"
                tabindex="2"
                auto-complete="on"
                @keyup.enter.native="handleLogin"
              />
            </div>
          </el-form-item>
          <el-button class="obtain">获取验证码</el-button>
        </div>

        <!-- 拖动滑块验证 -->
        <div
          ref="dragDiv"
          class="drag"
        >
          <div class="drag_bg" />
          <div class="drag_text">{{ confirmWords }}</div>
          <div
            ref="moveDiv"
            :class="{ handler_ok_bg: confirmSuccess }"
            class="handler handler_bg"
            style="position: absolute; top: 0px; left: 0px"
            @mousedown="mousedownFn($event)"
          />
        </div>

        <!-- 记住密码 and 忘记密码 -->
        <div v-if="mode == '0'" class="operation">
          <el-checkbox v-model="loginForm.checked" style="color:#333333;font-weight: 400;">记住密码</el-checkbox>
          <router-link
            :to="{ path: '/login/forget-password' }"
            style="
              font-size: 14px;
              font-family: SimSun;
              font-weight: 400;
              color: #333333;
            "
          >忘记密码</router-link>
        </div>
        <el-button
          :loading="loading"
          class="login"
          :style="{marginTop:(mode=='1'?'60px':'')}"
          @click.native.prevent="handleLogin"
        >登录</el-button>
        <div class="line" />
        <!-- <div class="tips">
          <span style="margin-right: 20px">username: admin</span>
          <span> password: any</span>
        </div> -->
        <div class="form-footer">
          <router-link :to="{ path: '/login/register' }">立即注册 <svg-icon icon-class="more-red" /></router-link>
        </div>
      </el-form>
    </div>
    <Footer />
  </div>
</template>

<script>
// import { validUsername } from '@/utils/validate'
import request from '@/utils/request'
import("./pic")
export default {
  name: 'Login',
  data() {
    // const validateUsername = (rule, value, callback) => {
    //   if (value.length < 11) {
    //     callback(new Error('Please enter the correct user name'))
    //   } else {
    //     callback()
    //   }
    // }
    // const validatePassword = (rule, value, callback) => {
    //   if (value.length < 6) {
    //     callback(new Error('The password can not be less than 6 digits'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      loginForm: {
        userPhone: '',
        userPassword: '',
        userCode: '',
        OperationType: '1',
        checked: false
      },
      mode: '0', // 帐号登录或者验证码登录 0帐号 1验证码
      beginClientX: 0 /* 距离屏幕左端距离*/,
      mouseMoveStata: false /* 触发拖动状态  判断*/,
      maxwidth: '' /* 拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: '拖动滑块验证' /* 滑块文字*/,
      confirmSuccess: false /* 验证成功判断*/,
      loginRules: {
        username: [
          { required: true, trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur' }
        ],
        userPhone: [
          { required: true, trigger: 'blur', message: '请输入用户名/手机号' }
        ],
        userPassword: [
          { required: true, trigger: 'blur', message: '请输入密码' }
        ]
      },
      loading: false,
      passwordType: 'password',
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    if (localStorage.getItem('userInfo')) {
      this.$router.push({
        path: '/'
      })
    }
  },
  mounted() {
    this.getCookie() // 读取是否记住密码
    // 滑块事件
    this.maxwidth =
      this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth
    document
      .getElementsByTagName('html')[0]
      .addEventListener('mousemove', this.mouseMoveFn)
    document
      .getElementsByTagName('html')[0]
      .addEventListener('mouseup', this.moseUpFn)
  },

  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    changeMode(mode) {
      // // 改变登录方式
      // this.mousedownFn()
      this.mode = mode
    },
    handleLogin() {
      // console.log(this.confirmSuccess)
      if (this.confirmSuccess === true) {
        if (this.loginForm.checked === true) {
          this.setCookie(
            this.loginForm.userPhone,
            this.loginForm.userPassword,
            7,
            this.loginForm.checked
          )
        } else {
          // console.log('清空Cookie')
          this.clearCookie()
        }
        /** 如果滑块验证通过 */
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.loading = true
            if (this.mode === '0') {
              var formData = {
                userPhone: this.loginForm.userPhone,
                userPassword: this.loginForm.userPassword,
                OperationType: '1'
              }
              this.$store
                .dispatch('user/login', formData)
                .then((res) => {
                //   const company = `${res.data.userInfo.fuserName}--${res.data.userInfo.FCompanyName}`
                //   sessionStorage.setItem('company', company)
                  if (!res.data) {
                    this.$message.error(res.msg)
                    this.loading = false
                    this.$router.push({
                      name: 'register',
                      params: {
                        name: 'register',
                        userInfo: JSON.stringify(formData)
                      }
                    })
                    return
                  }
                  //   request({
                  //     url: `/mall/mallmanage/demanduserdepart/queryDemanduserdepartInfo?FID=${res.data.userInfo.fuserId}`,
                  //     method: 'post'
                  //   })
                  //     .then(res => {
                  //       console.log(res)
                  //     })

                  // 用户权限配置
                  this.$store.dispatch('user/userSetRoute', this.$router.options.routes)
                  this.$forceUpdate()
                  this.$router.push({ path: this.redirect || '/' })
                  this.loading = false
                })
                .catch((res) => {
                //   console.log('error submit')
                  this.loading = false
                })
            } else {
              var formCodeData = {
                userPhone: this.loginForm.userPhone,
                userPassword: this.loginForm.userPassword,
                userCode: this.loginForm.userCode,
                OperationType: '1'
              }
              this.$store
                .dispatch('user/login', formCodeData)
                .then(() => {
                  this.$router.push({ path: this.redirect || '/' })
                  this.loading = false
                })
                .catch(() => {
                  this.loading = false
                })
            }
          } else {
            // console.log('error submit!!')
            return false
          }
        })
      } else {
        this.$message.error('请拖动滑块进行验证后登录')
      }
    },
    // 设置cookie
    setCookie(c_name, c_pwd, exdays, c_checked) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        'userPhone' + '=' + c_name + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'userPassword' + '=' + c_pwd + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'checked' + '=' + c_checked + ';path=/;expires=' + exdate.toGMTString()
    },
    // 读取cookie
    getCookie: function() {
      var that = this
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
        // console.log('读取密码', arr)
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            that.loginForm.userPhone = arr2[1] // 保存到保存数据的地方
            // console.log(arr2[1])
          } else if (arr2[0] === 'userPwd') {
            that.loginForm.userPassword = arr2[1]
            // console.log(arr2[1])
          } else if (arr2[0] === 'checked') {
            if (arr2[1] === 'true') {
              that.$set(that.loginForm, 'checked', true)
            } else {
              that.$set(that.loginForm, 'checked', false)
            }
            // console.log(arr2[1])
          }
        }
      }
    },
    // 清除cookie
    clearCookie: function() {
      this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
    },
    mousedownFn: function(e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault() // 阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true
        this.beginClientX = e.clientX
      }
    },
    // 滑块mousedoen 事件
    successFunction() {
      this.confirmSuccess = true
      this.confirmWords = '验证通过'
      if (window.addEventListener) {
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mousemove', this.mouseMoveFn)
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mouseup', this.moseUpFn)
      } else {
        document
          .getElementsByTagName('html')[0]
          .removeEventListener('mouseup', () => { })
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left =
        this.maxwidth + 'px'
      document.getElementsByClassName('drag_bg')[0].style.width =
        this.maxwidth + 'px'
    },
    // 验证成功函数
    mouseMoveFn(e) {
      if (this.mouseMoveStata) {
        const width = e.clientX - this.beginClientX
        if (width > 0 && width <= this.maxwidth) {
          document.getElementsByClassName('handler')[0].style.left =
            width + 'px'
          document.getElementsByClassName('drag_bg')[0].style.width =
            width + 'px'
        } else if (width > this.maxwidth) {
          this.successFunction()
        }
      }
    },
    // 滑块mousemove事件
    moseUpFn(e) {
      this.mouseMoveStata = false
      var width = e.clientX - this.beginClientX
      if (width < this.maxwidth) {
        document.getElementsByClassName('handler')[0].style.left = 0 + 'px'
        document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px'
      }
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #9999;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input :-webkit-autofill{
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
 background: linear-gradient(0deg, #EC212D 12%, #EF2F3B 46%, #F65A63 100%);
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #999999;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 100px #fff inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: #fff;
    color: #9999;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
  }
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #F32823 !important;
  background-color: #F32823 !important;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #333333 !important;
  }
  .el-checkbox__inner:hover{
  border-color: #F32823 !important;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #F32823 !important;
  }

}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  min-width: 1200px;
  background-color: $bg;
  overflow: hidden;
  .content {
    min-height: calc(100vh - 104px);
    width: 1200px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-around;
    margin: 0 auto;
    .login-form {
      position: relative;
      // right: 84px;
      // top: 204px;
      padding: 10px 20px 0;
      overflow: hidden;
      min-width: 370px;
      height: 494px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
    }
    .login-left{
      min-width: 500px;
      height: 360px;
      display: flex;
      // justify-content: center;
      align-items: center;
      flex-direction: column;
      .login-left-text{
        font-size: 50px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 10px;
      }
      .login-left-image{
        display: flex;
        align-items: center;
        margin-top: 45px;
        img{
          width: 200px;
          height: 230px;
          border: 1px solid #fff;
          margin-right: 30px;
        }
      }
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }
  // 账号/验证码登录字样
  .title-container {
    position: relative;
    display: flex;
    align-items: center;
    height: 60px;
    margin-bottom: 30px;
    div {
      width: 38%;
      height: 60px;
      display: flex;
      align-items: center;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      cursor: default;
    }
    .select {
      color: #EC212D;
    }
    div:first-child:after {
      content: "";
      width: 1px;
      height: 22px;
      background: #000000;
      opacity: 0.1;
      margin: 0 21px 0 20px;
    }

    .no-select {
      font-weight: 400;
      color: #333333;
    }
    // .title {
    //   font-size: 26px;
    //   color: $light_gray;
    //   margin: 0px auto 40px auto;
    //   text-align: center;
    //   font-weight: bold;
    // }
  }
  // 二维码切换登录
  .code {
    position: absolute;
    top: 0;
    right: 0;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .obtain {
    //获取验证码
    width: 118px;
    height: 40px;
    background: #EC212D;
    border-radius: 2px;
    opacity: 0.6;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0 0 10px;
  }

  // 滑块验证 start
  .drag {
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 34px;
    line-height: 34px;
    text-align: center;
    margin-bottom: 20px;
  }
  .handler {
    width: 40px;
    height: 32px;
    border: 1px solid #ccc;
    cursor: move;
  }
  .handler_bg {
    background: #fff
      url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==")
      no-repeat center;
  }
  .handler_ok_bg {
    background: #fff
      url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==")
      no-repeat center;
  }
  .drag_bg {
    background-color: #7ac23c;
    height: 34px;
    width: 0px;
  }
  .drag_text {
    position: absolute;
    top: 0px;
    width: 100%;
    text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
  }
  // end

  // 忘记密码 and 记住密码  start
  .operation {
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  //登录
  .login {
    width: 100%;
    margin-bottom: 30px;
    background: #EC212D;
    border-radius: 2px;
    color: #fff;
    font-size: 18px;
  }
  .line {
    width: 100%;
    height: 1px;
    background: #000000;
    opacity: 0.1;
  }
  .form-footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #EC212D;
    cursor: pointer;
    a{
      color: #EC212D;
    }
  }
}
</style>
